import { useTranslation } from "react-i18next";
import { classNames, getErrorMessages } from "../../Utils";
import FormLabel from "../FormLabel";
import { RefreshIcon } from "@heroicons/react/outline";

const ErrorSelect = ({
  name,
  label,
  error,
  customClassNames,
  addButtonTitle,
  onRefresh = () => {},
  onClickAddButton = () => {},
}) => {
  const { t } = useTranslation();
  const messages = getErrorMessages(error);
  return (
    <div>
      {label && (
        <div className="flex justify-between">
          <FormLabel htmlFor={name} label={t(label)} />
          {addButtonTitle && (
            <button
              type="button"
              onClick={onClickAddButton}
              className="text-blue-600 text-sm font-medium"
            >
              {t(addButtonTitle)}
            </button>
          )}
        </div>
      )}
      <div className="relative">
        <input
          type="text"
          name={name}
          id={name}
          value={messages}
          className={classNames(
            customClassNames,
            "mt-1 pr-3 py-2 w-full text-sm rounded-md shadow-sm border-red-500 text-red-500"
          )}
          disabled={error}
        />
        <button
          type="button"
          onClick={onRefresh}
          className="absolute inset-y-0 right-0 px-2 py-1 flex items-center"
        >
          <RefreshIcon className="w-6 h-6 text-blue-500" />
        </button>
      </div>
    </div>
  );
};

export default ErrorSelect;
